import { render, staticRenderFns } from "./FallbackAd.vue?vue&type=template&id=33d8e8df"
import script from "./FallbackAd.vue?vue&type=script&lang=js"
export * from "./FallbackAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports